import { NAV_ITEMS } from "@/mocks/news";

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold tracking-wide">每日爆料</span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100/80">
              面向全网征集热点线索与曝光素材的议题跟进平台。真实核实、来源保密、有误必纠，
              努力让每一份有价值的线索被看见、被推动。
            </p>
            <p className="mt-4 text-sm text-primary-200/80">
              官方邮箱：liuyan@meiribaoliao.example
            </p>
          </div>

          <nav aria-label="页脚栏目">
            <h4 className="text-sm font-semibold text-primary-50">内容栏目</h4>
            <ul className="mt-4 space-y-2.5">
              {NAV_ITEMS.slice(0, 4).map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="text-sm text-primary-100/80 transition-colors hover:text-white">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="投稿支持">
            <h4 className="text-sm font-semibold text-primary-50">投稿支持</h4>
            <ul className="mt-4 space-y-2.5">
              {NAV_ITEMS.slice(4).map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="text-sm text-primary-100/80 transition-colors hover:text-white">
                    {item.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="#contact" className="text-sm text-primary-100/80 transition-colors hover:text-white">
                  我要爆料
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-700/40 pt-6 sm:flex-row">
          <p className="text-xs text-primary-200/70">
            © {new Date().getFullYear()} 每日爆料网 版权所有
          </p>
          <p className="text-xs text-primary-200/70">
            坚持事实核实 · 保护来源隐私 · 有误必纠
          </p>
        </div>
      </div>
    </footer>
  );
}